import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

// /**
//  * @module FetchHooks
//  */
// /**
//  * @module Efacturs
//  */

/**
 *
 * @param {Object} prop
 * @param {Object} props.filters
 * @param {string} props.filters.documentType
 */

const useFetchEfacturas = ({ documentType }) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    const url = `/efactura/compras/?idioma=01&tipo_documento=${documentType || ''}`

    axios
      .get(url)
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [documentType])

  useEffect(() => {
    if (!loading) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentType])

  return { response, error, loading, reFetch: fetchData }
}

export default useFetchEfacturas
